import React from 'react';
import { Link } from 'react-router-dom';
import { ButtonWIcon } from './Inputs';

const ServerErrorPage = () => {
    return (
        <div className="server-error">
            <h1>Server Error</h1>
            <p>Oops! Něco se pokazilo</p>
            <Link to="/"><ButtonWIcon text={"Zkusit znovu"} iconSrc={"/img/reload.png"}></ButtonWIcon></Link>
        </div>
    );
};

export default ServerErrorPage;